import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "title", "href", "open", "tokens", "onClick", "onClickAway"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useRef, forwardRef, useId } from 'react';
import { useClickAway } from 'react-use';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import ToggleIcon from '../ToggleIcon';
import * as views from './Link.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var BaseLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      title = _ref.title,
      href = _ref.href,
      open = _ref.open,
      tokens = _ref.tokens,
      onClick = _ref.onClick,
      onClickAway = _ref.onClickAway,
      rest = _objectWithoutProperties(_ref, _excluded);

  var id = useId();
  var dropDownId = "dropdown-".concat(id);
  var wrapperRef = useRef(null);
  useClickAway(wrapperRef, function () {
    if (open) {
      onClickAway === null || onClickAway === void 0 ? void 0 : onClickAway();
    }
  });
  return _jsxs(views.Wrapper, {
    ref: wrapperRef,
    children: [_jsxs(views.Link, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, href ? {
      as: "a",
      href: href
    } : {
      'aria-controls': dropDownId,
      'aria-expanded': open
    }), {}, {
      ref: ref,
      onClick: onClick
    }, tokens), rest), {}, {
      children: [title, typeof open === "boolean" && _jsx(ToggleIcon, {
        open: open
      })]
    })), open && _jsx(views.DropdownWrapper, {
      id: dropDownId,
      children: children
    })]
  });
});
var Link = withDesignTokens(BaseLink, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100],
    openColor: theme.palette.twilio.blue[60],
    hoverColor: theme.palette.twilio.blue[60]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      openColor: theme.palette.brand.segmentGreen[500],
      hoverColor: theme.palette.brand.segmentGreen[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      openColor: theme.palette.brand.segmentGreen[500],
      hoverColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
export default Link;